import { customBaseQuery } from '@/lib/baseQuery';
import { createApi, FetchArgs } from '@reduxjs/toolkit/query/react';

export interface CreditRepresentativeDetail {
  firstName: string;
  lastName: string;
}

export interface GenerateCsaPdfPayload {
  creditRepresentativeDetails: CreditRepresentativeDetail[];
  creditLicence: string;
  creditRepresentative: string;
  date: string | null;
  servicePackage?: string[];
}

export const csaPdfApi = createApi({
  reducerPath: 'csaPdfApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    generateCsaPdf: builder.mutation<Blob, GenerateCsaPdfPayload>({
      queryFn: async (body, _api, _extra, baseQuery) => {
        const result = await baseQuery({
          url: 'v1/pdf/generate/csa',
          method: 'POST',
          body,
          responseHandler: (response) => response.blob(),
          cache: 'no-cache',
        } as FetchArgs);

        if (result.error) {
          return { error: result.error };
        }
        return { data: result.data as Blob };
      },
    }),
  }),
});

export const { useGenerateCsaPdfMutation } = csaPdfApi;
